// extracted by mini-css-extract-plugin
export default {"modal":"ModalDialog_modal__Y6dIh","modalOverlay":"ModalDialog_modalOverlay__3rut5","modalClose":"ModalDialog_modalClose__jQGCM"};